module.exports = __webpack_public_path__ + "static/media/search.357139cf.svg";